module.exports = __webpack_public_path__ + "static/media/nailpol.62986024.jpg";